import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

interface SinglesParticipant {
  firstName: string;
  lastName: string;
}

interface DoublesParticipant {
  p1: { firstName: string; lastName: string };
  p2: { firstName: string; lastName: string };
}

interface Registration {
  id: number;
  player: SinglesParticipant | null;
  pair: DoublesParticipant | null;
}

interface CategoryWithParticipants {
  id: number;
  name: string;
  registrations: Registration[];
}

interface ParticipantsData {
  categories: CategoryWithParticipants[];
}

const Participants: React.FC = () => {
  const { id: tournamentId } = useParams<{ id: string }>();
  const [data, setData] = useState<ParticipantsData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!tournamentId) {
      return;
    }

    fetch(`/api/public/events/${tournamentId}/participants`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }

        return res.json();
      })
      .then((result: ParticipantsData) => {
        setData(result);
        setLoading(false);
      })
      .catch(() => {
        setError('Nie udało się załadować listy uczestników.');
        setLoading(false);
      });
  }, [tournamentId]);

  if (loading) {
    return <div className="participants-loading">Ładowanie...</div>;
  }

  if (error || !data) {
    return <div className="participants-error">{error ?? 'Błąd ładowania.'}</div>;
  }

  return (
    <div className="participants">
      <Link to={`/events/${tournamentId}`} className="participants-back">
        ← Powrót do turnieju
      </Link>
      <h1>Uczestnicy</h1>
      {data.categories.map((cat) => (
        <section key={cat.id} className="participants-category">
          <h2 className="participants-category-name">{cat.name}</h2>
          {cat.registrations.length === 0 ? (
            <p className="participants-empty">Brak zapisanych.</p>
          ) : (
            <ol className="participants-list">
              {cat.registrations.map((reg) => (
                <li key={reg.id} className="participants-item">
                  {reg.player && (
                    <span>{reg.player.firstName} {reg.player.lastName}</span>
                  )}
                  {reg.pair && (
                    <span>
                      {reg.pair.p1.firstName} {reg.pair.p1.lastName}
                      {' / '}
                      {reg.pair.p2.firstName} {reg.pair.p2.lastName}
                    </span>
                  )}
                </li>
              ))}
            </ol>
          )}
        </section>
      ))}
    </div>
  );
};

export default Participants;
